import React, { Dispatch, FC, SetStateAction } from "react";
import { useOnChangeChildDispatch } from "utils/OnChange";
import { SearchWidgetBubbleThemeBuilder } from "./BubbleThemeBuilder";
import { ThemeBuilderSection } from "../WidgetThemeBuilder/ThemeBuilderSection";
import { SearchWidgetBubblesTheme } from "./SearchWidgetTypes";

export interface SearchWidgetBubblesThemeBuilderProps {
    readonly theme: SearchWidgetBubblesTheme | undefined;
    readonly defaultTheme: SearchWidgetBubblesTheme | undefined;
    readonly onChange: Dispatch<SetStateAction<SearchWidgetBubblesTheme>>;
}

const EMPTY_THEME: SearchWidgetBubblesTheme = {};

const SearchWidgetBubblesThemeBuilderInner: FC<SearchWidgetBubblesThemeBuilderProps> = props => {
    const theme: SearchWidgetBubblesTheme = props.theme ?? EMPTY_THEME;
    const defaultTheme: SearchWidgetBubblesTheme = props.defaultTheme ?? EMPTY_THEME;

    const { onChange } = props;

    const handleOthersChange = useOnChangeChildDispatch("others", onChange);

    return (
        <ThemeBuilderSection heading="Bubbles">
            <SearchWidgetBubbleThemeBuilder key="others" label="Others" theme={theme.others} defaultTheme={defaultTheme.others} onChange={handleOthersChange} />
        </ThemeBuilderSection>
    );
};

export const SearchWidgetBubblesThemeBuilder = React.memo(SearchWidgetBubblesThemeBuilderInner);
